module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-PattAndLilySymbol-640.467acec8.jpg";